<template>
    <div class="department-container">
        <div class="department-header">
            <span class="department-add">Departments</span>
            <v-tooltip bottom>
                <v-btn flat color="black" slot="activator" @click="addDepartmentItem" class="item-add-button-icon">
                    <v-icon large color="indigo">mdi-plus</v-icon>
                </v-btn>
                <div>Add new department</div>
            </v-tooltip>
        </div>
        <div>
            <AppTable :data="departmentsData" :owner="'department'" :saving="saving" @deleteItem="deleteDepartmentItem" @saveItem="saveDepartment" @cancelEdit="cancelEditDepartmentItem"
                @editItem="editDepartmentItem" class="department-table" />
        </div>
     </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';

    import AppTable from '@/components/common/AppTable';

    export default {
        name: 'department-settings',
        components: {
            AppTable
        },
        data() {
            return {
                saving: false
            };
        },
        computed: {
            ...mapGetters({ departments: 'getDepartments' }),
            departmentsData() {
                return {
                    items: [
                        ...this.departments
                    ]
                };
            }
        },
        methods: {
            ...mapActions([
                'deleteDepartment',
                'addDepartment',
                'editDepartment',
                'cancelEditDepartment',
                'changeDepartment',
                'createNewDepartment'
            ]),
            deleteDepartmentItem(index) {
                this.deleteDepartment(index);
            },
            addDepartmentItem() {
                this.addDepartment({
                    id: -1,
                    name: '',
                    editting: true,
                    editable: true
                });
            },
            editDepartmentItem(departmentId) {
                this.editDepartment(departmentId);
            },
            cancelEditDepartmentItem() {
                this.cancelEditDepartment();
            },
            saveDepartment(payload) {
                this.saving = true;
                if (payload.id > 0) {
                    this.changeDepartment(payload).then(() => {
                        this.saving = false;
                    });
                } else {
                    this.createNewDepartment(payload.name).then(() => {
                        this.saving = false;
                    });
                }
            }
        }
    };
</script>
<style scoped>
.department-container {
    padding-bottom: 26px;
}

.department-header {
    font-size: 24px;
    padding-left: 24px;
    padding-bottom: 14px;
    margin-top: 10px;
}

.department-table {
    margin: 0 26px;
}

.department-add {
    margin-right: 15px;
}

@media screen and (max-width: 600px) {
    .department-table {
        margin: 0 13px;
    }
    
    .card__text {
        padding-left: 8px;
        padding-right: 8px;
    }

    .department-header {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/DepartmentSettings.vue